"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.END = exports.HOME = exports.ESC = exports.DOWN = exports.UP = exports.TAB = exports.SPACE = exports.ENTER = void 0;
var ENTER = [13, 'Enter'];
exports.ENTER = ENTER;
var SPACE = [32, ' ', 'Spacebar'];
exports.SPACE = SPACE;
var TAB = [9, 'Tab'];
exports.TAB = TAB;
var UP = [38, 'ArrowUp'];
exports.UP = UP;
var DOWN = [40, 'ArrowDown'];
exports.DOWN = DOWN;
var ESC = [27, 'Escape'];
exports.ESC = ESC;
var HOME = [36, 'Home'];
exports.HOME = HOME;
var END = [35, 'End'];
exports.END = END;